import { processOpenActionRequest } from '../open-action-helper';
import type { Action } from '../../store/state/state-manager';

export const processOpenProcessActionRequest = (
  actionInPayload: Action['payload'],
  options: { actionMgrID?: number; isProcessAction: boolean }
) => {
  return processOpenActionRequest(actionInPayload, options);
};

export default {
  processOpenProcessActionRequest
};
